import React, { useCallback, useEffect, useRef, useMemo, useState } from 'react';
import * as echarts from 'echarts';
import { Dropdown, DropdownOption } from '@abb/abb-common-ux-react';
import energyData from './energy-data.json';
import axios from 'axios';
import './energy-data.css';
import { getToken } from "../../Authentication/get-token";
import { BASE_URL } from '../../../strings';
import "./energy-data.css"
const EnergyData = () => {
  const chartRef = useRef(null);
  const [apiData, setApiData] = useState([]);

  const [dropdownValues, setDropdownValues] = useState(
    energyData.dropdowns.reduce((acc, dropdown) => {
      acc[dropdown.key] = dropdown.placeholder;
      return acc;
    }, {})
  );

  const fetchEnergyData = useCallback(async () => {
    try {
      const response = await axios.get(`${BASE_URL}emapi/energy_data`, getToken());
      setApiData(response.data?.data || []);
    } catch (error) {
      console.error('Failed to fetch energy data:', error);
    }
  }, []);

  useEffect(() => {
    fetchEnergyData();
  }, [fetchEnergyData]);

  const chartOptions = useMemo(() => {
    return {
      tooltip: {
        trigger: energyData.tooltip.trigger,
        axisPointer: {
          type: energyData.tooltip.axisPointer.type,
        },
      },
      xAxis: {
        type: energyData.xAxis.type,
        data: apiData.map((item) => item.name),
        axisTick: { alignWithLabel: true },
        name: energyData.xAxis.name,
        axisLabel: {
          padding: energyData.xAxis.axisLabel.padding,
        },
        nameLocation: energyData.xAxis.nameLocation,
        nameGap: 30,
      },
      yAxis: {
        type: energyData.yAxis?.type,
        axisLabel: {
          padding: energyData.yAxis.axisLabel.padding,
          verticalAlign: energyData.yAxis.axisLabel.verticalAlign,
          lineHeight: energyData.yAxis.axisLabel.lineHeight,
        },
        name: energyData.yAxis.name,
        nameLocation: energyData.yAxis.nameLocation,
        nameRotate: energyData.yAxis.nameRotate,
        nameGap: 30,
      },
      series: [
        {
          type: energyData.series?.type,
          data: apiData.map((item) => item.value),
          itemStyle: {
            color: '#FF4754',
          },
        },
      ],
    };
  }, [apiData]);

  useEffect(() => {
    if (!chartRef.current || apiData.length === 0) return;

    const chart = echarts.init(chartRef.current);
    chart.setOption({
      ...chartOptions,
      grid: {
        left: '5%',
        right: '2%',
        top: '12%',
        bottom: '16%',
        containLabel: true
      }
    });

    // Add resize listener for responsiveness
    const handleResize = () => {
      chart.resize();
    };

    // ResizeObserver for container size changes
    const resizeObserver = new ResizeObserver(() => {
      handleResize();
    });

    window.addEventListener('resize', handleResize);
    resizeObserver.observe(chartRef.current);

    // Initial resize to ensure proper sizing
    setTimeout(handleResize, 100);

    return () => {
      window.removeEventListener('resize', handleResize);
      resizeObserver.disconnect();
      chart.dispose();
    };
  }, [chartOptions, apiData]);

  const handleDropdownChange = (key, value) => {
    setDropdownValues({ ...dropdownValues, [key]: value });
  };

  const dropdowns = useMemo(() => {
    return energyData.dropdowns.map((dropdown, index) => (
      <Dropdown
        key={`dropdown-${dropdown.key}-${index}`}
        label={dropdown.label}
        placeholder={dropdown.placeholder}
        value={dropdownValues[dropdown.key]}
        onChange={(value) => handleDropdownChange(dropdown.key, value)}
      >
        {dropdown.options.map((option) => (
          <DropdownOption key={option.key} label={option.label} value={option.value} />
        ))}
      </Dropdown>
    ));
  }, [energyData.dropdowns, dropdownValues]);

  return (
    <div className='energy-data-block'>
      <div className='indicator-container-line'>{dropdowns}</div>
      <div className='energy-chart-container'>
        <div
          ref={chartRef}
          className='energy-chart'
        />
      </div>
    </div>
  );
};

export default EnergyData;
